<template>
<div>
    <div class="portal-tab-div">
        <div class="div-block-1998">
            <div class="text-block-1321">STOCK UP BEFORE FDA CRACKDOWN</div>
            <div class="text-block-1319">LOCK IN TIRZEPATIDE<br>FOR 12 MONTHS</div>
            <p class="paragraph-166">The landscape for compounded Tirzepatide is evolving, and future availability remains uncertain. However, we’re committed to ensuring continued access for our current patients. Secure your supply for the next 12 months by selecting a 3-month renewal plan below.</p>
            <div class="bullets-timer-div" style="justify-content: center;">
                <div class="portal-bullets-div">
                    <div class="div-block-2000"><img src="images/icon_Check-green.svg" loading="lazy" alt="" class="image-562">
                        <div class="text-block-1320">Extend current prescription for 12 months.</div>
                    </div>
                    <div class="div-block-2000"><img src="images/icon_Check-green.svg" loading="lazy" alt="" class="image-562">
                        <div class="text-block-1320">Revisit with doctor for new prescription.</div>
                    </div>
                    <div class="div-block-2000"><img src="images/icon_Check-green.svg" loading="lazy" alt="" class="image-562">
                        <div class="text-block-1320">Requires Doctor Check In every 90 Days.</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="_3-products-div">
            <div class="portal-product-box">
                <div class="ppb_imgdiv"><img src="images/PM_Square-Tirzwht.png" loading="lazy" sizes="(max-width: 767px) 100vw, (max-width: 991px) 728px, 940px" srcset="images/PM_Square-Tirzwht-p-500.png 500w, images/PM_Square-Tirzwht-p-800.png 800w, images/PM_Square-Tirzwht.png 1080w" alt="" class="image-560"><img src="images/icon_RX-white.svg" loading="lazy" alt="" class="image-561"></div>
                <div class="ppb_infodiv">
                    <div class="ppb_name-price">
                        <div class="ppb_name">
                            <div class="text-block-1308">3 Month Plan<br></div>
                            <div class="text-block-1309">Lock in 12 months of refills</div>
                        </div>
                        <div class="pbb_price">
                            <div class="pbb_priceflex">
                                <div class="text-block-1311">$</div>
                                <div class="text-block-1310">749</div>
                                <div class="text-block-1311">.97</div>
                            </div>
                            <div class="text-block-1312">$249.99/mo.</div>
                        </div>
                    </div>
                    <p class="paragraph-165">Pay up front for <strong>3 months</strong> and receive 12 months of refills.</p>
                    <ul role="list" class="list-13">
                        <li class="list-item-11">
                            <div class="text-block-1313">All Dosages Same Price.</div>
                        </li>
                        <li class="list-item-11">
                            <div class="text-block-1313">Doctor Visit Included.</div>
                        </li>
                        <li class="list-item-11">
                            <div class="text-block-1313">12 Months of Refills (provided ONLY by our pharmacy partner and after doctor checkin)</div>
                        </li>
                    </ul>
                </div>
                <div class="ppb_timer-buttondiv">
                    <a data-w-id="70659169-9968-70a7-0a4b-da20131c391a" href="#" class="button-132 w-button" @click.prevent="showDialogandSetPricing(3)">BUY NOW!</a>
                </div>
            </div>
            <!--<div class="portal-product-box">
                <div class="ppb_imgdiv"><img src="images/PM_Square-Tirzwht.png" loading="lazy" sizes="(max-width: 767px) 100vw, (max-width: 991px) 728px, 940px" srcset="images/PM_Square-Tirzwht-p-500.png 500w, images/PM_Square-Tirzwht-p-800.png 800w, images/PM_Square-Tirzwht.png 1080w" alt="" class="image-560"><img src="images/icon_RX-white.svg" loading="lazy" alt="" class="image-561"></div>
                <div class="ppb_infodiv">
                    <div class="ppb_name-price">
                        <div class="ppb_name">
                            <div class="text-block-1308">6 Month Plan<br></div>
                            <div class="text-block-1309">Lock in 12 months of refills</div>
                        </div>
                        <div class="pbb_price">
                            <div class="pbb_priceflex">
                                <div class="text-block-1311">$</div>
                                <div class="text-block-1310">1149</div>
                                <div class="text-block-1311">.97</div>
                            </div>
                            <div class="text-block-1312">$191.66/mo</div>
                        </div>
                    </div>
                    <p class="paragraph-165">Pay up front for <strong>6 months</strong> and receive 12 months of refills.</p>
                    <ul role="list" class="list-13">
                        <li class="list-item-11">
                            <div class="text-block-1313">All Dosages Same Price.</div>
                        </li>
                        <li class="list-item-11">
                            <div class="text-block-1313">Doctor Visit Included.</div>
                        </li>
                        <li class="list-item-11">
                            <div class="text-block-1313">12 Months of Refills (provided ONLY by our pharmacy partner and after doctor checkin)</div>
                        </li>
                    </ul>
                </div>
                <div class="ppb_timer-buttondiv">
                    <a data-w-id="057cf4af-2c67-b290-7196-6d7b2f235196" href="#" class="button-132 w-button" @click.prevent="showDialogandSetPricing(6)">BUY NOW!</a>
                </div>
            </div>-->
        </div>
    </div>
    <div class="price-confirm-popup" style="display: flex;" v-if="showDialog">
        <div class="div-block-1997">
            <div class="text-block-1315">Payment Confirmation </div>
            <div class="text-block-1318">Click the button below to confirm payment for:</div>
            <div class="popup_pricediv">
                <div class="text-block-1316">$</div>
                <div class="text-block-1317" v-if="payMonths==6">1149.97</div>
                <div class="text-block-1317" v-else>749.97</div>
            </div>
            <div class="form-block-17 w-form">
                <form id="email-form-2" @submit.prevent="submitForm">
                    <button type="submit" class="submit-button-18 w-button" :disabled="submitted">
                        <div v-if="submitted">
                            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: none; display: block; shape-rendering: auto;" width="15px" height="15px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                                <circle cx="50" cy="50" fill="none" stroke="blue" stroke-width="10" r="35" stroke-dasharray="164.93361431346415 56.97787143782138">
                                    <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="0.53475935828877s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform>
                                </circle>
                            </svg>
                        </div>
                        <div v-else>
                            <div class="">CONFIRM</div>
                        </div>
                    </button>
                    <label class="w-checkbox checkbox-field-19">
                        <span class="checkbox-label-22 w-form-label" for="checkbox-3">
                            By clicking "Confirm" , You agree to the <a :href="`${appMainWeb}/returns`" target="_blank">Refund Policy</a>, <a :href="`${appMainWeb}/terms`" target="_blank">Terms and Conditions</a></span>
                    </label>
                </form>
                <div class="w-form-fail" style="display: block;" v-if="paymentError">
                    <div>{{errorMessage}}</div>
                </div>
            </div>
            <a data-w-id="48e7fdbd-f59f-a7e6-b609-34c307012fe5" href="#" class="link-block-87 w-inline-block" @click.prevent="showDialog=false;"><img src="images/icon_Close.svg" loading="lazy" alt=""></a>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: 'BuyMore',
    props: ['baseUrl', 'user'],
    // Add this to your component's data section
    data() {
        return {
            // Keep your existing data properties
            paymentAttempts: 0,
            maxPaymentAttempts: 3,
            appName: process.env.VUE_APP_COMPANY,
            appMainWeb: process.env.VUE_APP_HOMEPAGE,
            showDialog: false,
            payMonths: 3,
            submitted: false,
            paymentError: false,
            errorMessage: "Oops! an error occurred",

            // Add these new countdown properties
            countdownDays: '00',
            countdownHours: '00',
            countdownMinutes: '00',
            countdownSeconds: '00',
            countdownInterval: null
        }
    },

    // Keep your existing methods
    methods: {
        showDialogandSetPricing(val) {
            this.payMonths = val;
            this.showDialog = true;
        },
        async submitForm() {
            this.submitted = true;
            try {
                let response = await this.$axios.post(`${this.baseUrl}/api/buy-more`, {
                    paymentTerms: this.payMonths,
                    product_name: "Tirzepatide",
                    productId : "675ac4cb6bf102c19ec3afe9",
                    planId: 'tirz_plan_1'
                })
                if (response.data.status === 'success') {
                    this.submitted = false;
                    window.location.reload();
                } else {
                    this.paymentError = true;
                    this.errorMessage = response.data.message;
                    this.submitted = false;
                }
            } catch (error) {
                this.paymentError = true;
                this.errorMessage = error.response?.data?.message || "";
                this.submitted = false;
            }
        },

        // Add this new method for the countdown
        calculateCountdown() {
            // Create dates using numeric parameters (most reliable method)
            const now = new Date();
            const targetDate = new Date(2025, 2, 20, 23, 59, 59); // Month is 0-indexed, so 2 = March

            // Calculate time difference in milliseconds
            const diff = targetDate - now;

            // Handle case where countdown has ended
            if (diff <= 0) {
                this.countdownDays = '00';
                this.countdownHours = '00';
                this.countdownMinutes = '00';
                this.countdownSeconds = '00';

                if (this.countdownInterval) {
                    clearInterval(this.countdownInterval);
                }
                return;
            }

            // Calculate time units
            const days = Math.floor(diff / (1000 * 60 * 60 * 24));
            const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((diff % (1000 * 60)) / 1000);

            // Update data properties with leading zeros
            this.countdownDays = days.toString().padStart(2, '0');
            this.countdownHours = hours.toString().padStart(2, '0');
            this.countdownMinutes = minutes.toString().padStart(2, '0');
            this.countdownSeconds = seconds.toString().padStart(2, '0');
        }
    },

    mounted() {
        /* Calculate countdown immediately
        this.calculateCountdown();

        // Update countdown every second
        this.countdownInterval = setInterval(() => {
            this.calculateCountdown();
        }, 1000);*/
    },

    beforeDestroy() {
        /* Clear the interval when component is destroyed
        if (this.countdownInterval) {
            clearInterval(this.countdownInterval);
        }*/
    }
}
</script>
